<template>
  <div>
    <SelectSearch
      id="channel-staff"
      label="Participantes"
      hide-icon
      :value="undefined"
      placeholder="Adicionar participantes"
      value-label="fullName"
      value-detail="roleDescription"
      :search-function="searchStaff"
      :disabled="disabled"
      @input="addStaffToChannel"
    />

    <HHealthTeam
      class="channel-staff__list"
      :health-team="selectedStaffComputed"
      show-all
      has-actions
    >
      <template #actions="{ staff }">
        <nav class="channel-staff__actions">
          <span v-if="staff.onBackground" class="channel-staff__label">
            background
          </span>

          <WButton
            icon="icClose"
            size="small"
            icon-button
            variant="tertiary"
            :disabled="staff.id === user.id"
            @click="removeStaffFromChannel(staff)"
          />
        </nav>
      </template>
    </HHealthTeam>
  </div>
</template>

<script>
import { WButton } from '@alice-health/wonderland-vue'
import { mapState } from 'vuex'

import { HHealthTeam } from '@/components/profile/atoms'
import { SelectSearch } from '@/components/shared/atoms'

export default {
  components: { WButton, HHealthTeam, SelectSearch },
  props: {
    channelId: { type: String, default: undefined },
    channelName: { type: String, default: undefined },
    channelStaff: {
      type: Object,
      default: () => ({})
    },
    disabled: Boolean
  },
  emits: ['addStaff', 'removeStaff'],
  data() {
    return {
      selectedStaff: []
    }
  },
  computed: {
    ...mapState('user', ['user']),
    selectedStaffComputed() {
      if (this.channelStaff) {
        return Object.values(this.channelStaff)
          .sort((a, b) =>
            (a.fullName || a.firstName)?.localeCompare(
              b.fullName || b.firstName
            )
          )
          .sort((a, b) => a.onBackground - b.onBackground)
      }

      return {}
    },
    selectedStaffMapped() {
      return this.selectedStaff?.reduce(
        (map, staff) => ({
          ...map,
          [staff.id]: {
            id: staff.id,
            profileImageUrl: staff.profileImageUrl,
            fullName: staff.fullName,
            owner: Object.prototype.hasOwnProperty.call(staff, 'owner')
              ? staff.owner
              : staff.id === this.user.id,
            roles: staff.roles,
            lastSync: staff.lastSync || new Date()
          }
        }),
        {}
      )
    }
  },
  watch: {
    channelStaff: {
      immediate: true,
      handler() {
        this.selectedStaff = Object.values(this.channelStaff)
      }
    }
  },
  methods: {
    async searchStaff(query, signal) {
      return (
        (await this.$store.dispatch('staff/searchStaffForChannel', {
          query,
          signal
        })) || []
      )
    },
    addStaffToChannel(staff) {
      if (!staff) {
        return
      }
      this.selectedStaff.push(staff)

      this.$emit('addStaff', {
        staffId: staff.id,
        staff: this.selectedStaffMapped
      })
    },
    removeStaffFromChannel(staff) {
      const index = this.selectedStaff.findIndex(s => s.id === staff.id)
      this.selectedStaff.splice(index, 1)

      this.$emit('removeStaff', {
        staffId: staff.id,
        staff: this.selectedStaffMapped
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_non-rendering';
.channel-staff {
  &__list {
    margin-top: var(--gl-spacing-02);
  }

  &__item {
    padding-left: var(--gl-border-radius-xs);
    padding-right: var(--gl-border-radius-xs);

    button {
      opacity: 0;
      background-color: transparent !important;
    }

    &:hover {
      background-color: var(--sys-color-surface-container-hover);
      border-radius: var(--gl-border-radius-xs);

      button {
        opacity: 1;
      }
    }
  }

  &__item--background span {
    opacity: 0.5;
  }

  &__actions {
    align-items: center;
    display: flex;
    gap: var(--gl-spacing-08);
    grid-row: 1/3;
  }

  &__label {
    @extend %overline-small;
    background-color: var(--gl-color-shades-gray-20);
    border-radius: var(--gl-border-radius-xs);
    color: var(--sys-color-content-primary);
    padding: 1px var(--gl-spacing-02);
  }
}
</style>
